import { api } from '@services';

import qs from 'query-string';

import { IPaginationResult } from '@models/Equipment.model';
import { UpdateStatusType } from '@models/UpdateStatus.model';
import Update, {
  IUpdateRawQueryList,
  IUpdateRawQueryListApiModel,
} from '@models/Update.model';

export interface IGetStudioUpdates {
  manufactorNames?: string[];
  tagsNames?: string[];
  dateStart?: Date;
  dateEnd?: Date;
  type?: UpdateStatusType;
  sort?: string;
  direction?: 'ASC' | 'DESC';
  assignedToMe?: boolean;
}
export interface IPagination {
  page: number;
  limit: number;
  search: string;
  studioId: string;
}
interface IRequest {
  pagination: IPagination;
  filter?: IGetStudioUpdates;
}

const getStudioUpdates = async ({
  pagination,
  filter,
}: IRequest): Promise<IPaginationResult<IUpdateRawQueryList>> => {
  const query = {
    page: pagination?.page || 1,
    limit: pagination?.limit || 20,
    q: pagination.search,
    sort: filter?.sort,
    type: filter?.type,
    direction: filter?.direction,
    manufactorNames: filter?.manufactorNames?.join(','),
    tagsNames: filter?.tagsNames?.join(','),
    dateStart: filter?.dateStart
      ? new Date(filter.dateStart).toJSON()
      : undefined,
    dateEnd: filter?.dateEnd ? new Date(filter.dateEnd).toJSON() : undefined,
    assignedToMe: filter?.assignedToMe,
  };

  const queryString = qs.stringify(query);

  const { data: updateStatuses } = await api.get<
    IPaginationResult<IUpdateRawQueryListApiModel>
  >(`/studios/${pagination.studioId}/updates?${queryString}`);

  return Update.arrayPaginatedFromRawQueryListApiModel(updateStatuses);
};

export { getStudioUpdates };
